import {
    defaultOptions,
    nextArrowCustom,
    prevArrowCustom,
} from "../global/slick-options";

const blogSlider = jQuery('[data-slider="blog-slider"]');

if (blogSlider.length) {
    jQuery(blogSlider).slick({
        ...defaultOptions,
        prevArrow: prevArrowCustom(blogSlider),
        nextArrow: nextArrowCustom(blogSlider),
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: false,
                },
            },
            {
                breakpoint: 639,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    });
}
